import clsx from "clsx";
import Link from "next/link";
import { LoadingSkeleton } from "shared-components";

import type { JSX } from "react";

interface Props {
  links: {
    name: string;
    url: string;
    imageUrl?: string;
    className?: string;
  }[];
  loading?: boolean;
  loadingItemsNumber?: number;
  /** No desktop remove as bordas entre itens (visual do novo flyout). */
  plain?: boolean;
}

const baseItemClassName = "flex items-center border-b border-base-border py-1 last:border-none";

export const LinksList = ({ links, loading, loadingItemsNumber, plain }: Props): JSX.Element => {
  const itemClassName = clsx(baseItemClassName, plain ? "lg:border-none lg:py-[0.4rem]" : "lg:py-2");

  if (loading) {
    return (
      <>
        {Array.from({ length: loadingItemsNumber || 4 }, (_, index) => (
          <div className={itemClassName} key={index}>
            <LoadingSkeleton kind="paragraph" className="max-w-[14rem] lg:w-[10rem]" />
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      {links.map((link) => (
        <Link key={link.name} href={link.url} className={clsx(itemClassName, link.className)}>
          {link.imageUrl && (
            <div
              style={{ backgroundImage: `url(${link.imageUrl})` }}
              className="mr-1 h-3 w-3 min-w-3 bg-contain bg-center bg-no-repeat"
            />
          )}

          <span>{link.name}</span>
        </Link>
      ))}
    </>
  );
};
